export default __webpack_public_path__ + "static/media/staff_jg_sg_action.ad65bd04.svg";